import { useCallback } from 'react';
import { useMarketCouponRedeemAll } from '../queries/useMarketCouponRedeemAll';
import { useMyInfo } from 'shared/src/queries';
import { bridge } from 'shared/src/utils';
import { useLogCompleteDownloadCoupon } from './useLogCompleteDownloadCoupon';

export const useOnPressMarketCouponRedeemAll = (marketId: number) => {
  const { mutateAsync: redeemAllCoupon, isPending: loadingRedeemAllCoupon } =
    useMarketCouponRedeemAll(marketId);
  const { data: myInfo } = useMyInfo();
  const logCompleteRedeemCoupon = useLogCompleteDownloadCoupon(marketId);

  return {
    loading: loadingRedeemAllCoupon,
    action: useCallback(async () => {
      if (!myInfo) return;
      if (myInfo.is_anonymous) {
        bridge.assertLogin({});
        bridge.toast('로그인이나 회원가입이 필요해요');
        return;
      }
      redeemAllCoupon()
        .then(() => {
          logCompleteRedeemCoupon({ isDownloadAll: true });
        })
        .catch(() => {
          /* onError에서 toast로 처리됨 */
        });
    }, [myInfo, redeemAllCoupon, logCompleteRedeemCoupon]),
  };
};
